import { useEffect, useRef } from "react"
import { useMeta } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"

export default function CookieDeclaration() {
  const { cookiebotId } = useMeta()
  const ref = useRef()
  const isInitialized = useRef(false)

  useEffect(() => {
    if (isInitialized.current || !cookiebotId) {
      return
    }

    const script = document.createElement("script")
    script.src = `https://consent.cookiebot.com/${cookiebotId}/cd.js`
    script.setAttribute("id", "CookieDeclaration")
    script.setAttribute("type", "text/javascript")
    script.async = true
    ref.current.appendChild(script)

    isInitialized.current = true
  }, [cookiebotId])

  return (
    <Block width="column">
      <div id="cookieConsentDiv" ref={ref}></div>
    </Block>
  )
}
